export default __webpack_public_path__ + "static/media/pindown3.32751366.png";